import React from 'react';
import styled from '@emotion/styled';

const ListItem = styled.li`
  color: #fff;
  padding: 15px 0;
  border-bottom: 1px solid #82bae5;
`;

const Icon = styled.svg`
  display: inline-block;
  vertical-align: middle;
  margin-right: 10px;
  width: 44px;
  height: 44px;

  circle {
    fill: #fff;
  }

  path {
    fill: #4c96ce;
  }
`;

const Detail = styled.div`
  display: inline-block;
  vertical-align: middle;
`;

const EmailHeading = styled.span`
  font-size: 12px;
  display: block;
  padding-bottom: 5px;
`;

const UserEmail = styled.p`
  margin: 0;
  padding: 0;
  font-size: 14px;
  font-weight: 600;
`;

const validate = (email: string) => {
  return email && email !== '';
};

interface Props {
  email: string;
}

{
  /* Internationalise here */
}
const EmailDetail = (props: Props) => {
  const { email } = props;

  return (
    <ListItem>
      <Icon viewBox="0 0 44 44" data-testid="email-detail-email-icon">
        <circle cx="22" cy="22" r="22" />
        <path d="M22.5 25.74a.79.79 0 0 1-.5.26.8.8 0 0 1-.49-.21l-3-2.7-8 7.62a2.21 2.21 0 0 0 1.17.34h20.58a2.21 2.21 0 0 0 1.17-.34l-8-7.62zM9.5 14.8a2.27 2.27 0 0 0 0 .45v13.49a2.25 2.25 0 0 0 0 .38l7.66-7.32zm23.84-1.5a2.2 2.2 0 0 0-1.08-.3H11.74a2.2 2.2 0 0 0-1.12.31L22 23.72zm1.07 1.5l-7.65 7 7.66 7.32a2.26 2.26 0 0 0 0-.38V15.26a2.26 2.26 0 0 0 .03-.45z" />
      </Icon>
      <Detail>
        {validate(email) && (
          <>
            <EmailHeading>Email</EmailHeading>
            <UserEmail>{email}</UserEmail>
          </>
        )}
      </Detail>
    </ListItem>
  );
};

export { EmailDetail, EmailDetail as default };
